import { createFileRoute } from '@tanstack/react-router';
import { validateTableSearch } from '@utils/tabHelpers';

export const Route = createFileRoute('/w/users/')({
  validateSearch: (search: Record<string, unknown>) =>
    validateTableSearch(search, { sortBy: 'effectiveFrom', sortDir: 'desc', tab: 'ALL' }),
});
